<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        v-if="id === ''"
        @back="back"
        title
        :content="$t('adicionar-novo-atendimento')"
      ></el-page-header>
      <el-page-header
        v-if="id !== ''"
        @back="back"
        title
        :content="$t('atualizar-entregador')"
      ></el-page-header>
    </el-card>
    <br />
    <el-card>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-position="top"
      >
        <el-row :gutter="5">
          <el-col :xs="24" :sm="10" :md="10" :lg="5" :xl="5">
            <el-form-item :label="$t('codigo')" prop="code">
              <el-input
                ref="code"
                :disabled="id !== ''"
                v-model="ruleForm.code"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="14" :md="14" :lg="9" :xl="9">
            <el-form-item :label="$t('descricao')" prop="name">
              <el-input ref="name" v-model="ruleForm.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-form-item :label="$t('tipo-tarefa')" prop="type">
              <el-select
                v-model="ruleForm.type"
                placeholder="Selecione  uma opção"
              >
                <el-option key="1" label="Coleta" value="1"></el-option>
                <el-option key="2" label="Finalizar Rota" value="2"></el-option>
                <el-option key="3" label="Backoffice" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="3" :xl="3" :offset="1">
            <el-form-item :label="$t('ativo')" prop="active">
              <el-switch v-model="ruleForm.active"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5" :offset="1">
            <el-form-item
              :label="$t('recriar-atendimento-finalizar')"
              prop="recreated"
            >
              <el-switch v-model="ruleForm.recreated"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5" :offset="1">
            <el-form-item :label="$t('enviar-notificacao')" prop="notification">
              <el-switch v-model="ruleForm.notification"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-form-item :label="$t('entregador')" prop="courier">
              <CouriersList v-model="ruleForm.courier" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-form-item :label="$t('cliente')" prop="customer">
              <CustomerList v-model="ruleForm.customer" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
            <el-form-item :label="$t('prioridade')" prop="priority">
              <el-select
                v-model="ruleForm.priority"
                placeholder="Selecione  uma opção"
              >
                <el-option key="1" label="1" value="1"></el-option>
                <el-option key="2" label="2" value="2"></el-option>
                <el-option key="3" label="3" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
            <el-form-item :label="$t('situacao')" prop="situation">
              <el-select
                v-model="ruleForm.situation"
                placeholder="Selecione  uma opção"
              >
                <el-option key="1" label="Cliente 1" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
            <el-form-item :label="$t('origem')" prop="source">
              <el-select
                v-model="ruleForm.source"
                placeholder="Selecione  uma opção"
              >
                <el-option key="1" label="Cliente 1" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item :label="$t('execucao')" prop="executedAt">
          <el-date-picker
            v-model="ruleForm.executedAt"
            type="date"
            align="right"
            unlink-panels
            range-separator="à"
            format="dd/MM/yyyy"
            start-placeholder="Inicio"
            end-placeholder="Fim"
          ></el-date-picker>
        </el-form-item>
        <div class="bottom clearfix">
          <el-form-item>
            <el-button
              type="warning"
              v-if="id === ''"
              autofocus
              @click="submitForm('ruleForm')"
              >{{ $t("adicionar") }}</el-button
            >
            <el-button
              type="warning"
              v-if="id !== ''"
              autofocus
              @click="editForm('ruleForm')"
              >{{ $t("atualizar") }}</el-button
            >
            <el-button type="danger" @click="back()">{{
              $t("voltar")
            }}</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-card>
  </div>
</template> 
<script>
import { CallCenterService } from "@/services/customers/call.center.services";
import { i18n } from "@/plugin/i18n";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import CouriersList from "@/xpost/views/umov/couriers/CouriersList";

export default {
  name: "PackingAdd",
  components: {
    CustomerList,
    CouriersList,
  },
  data() {
    return {
      id: "",
      customers: [],
      couriers: [],
      ruleForm: {
        name: "",
        code: "",
        executedAt: new Date(),
        situation: "",
        priority: "",
        customer: "",
        courier: "",
        notification: false,
        recreated: false,
        type: "",
        active: true,
      },
      rules: {
        name: [
          {
            required: true,
            message: i18n.tc("nome-obrigatorio"),
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: i18n.tc("codigo-obrigatorio"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    back() {
      this.$router.replace({ name: "call.center" });
    },
    get() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      CallCenterService.get(vm.id)
        .then((response) => {
          vm.ruleForm = response;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    submitForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading({
            lock: true,
            text: i18n.tc("carregando"),
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          CallCenterService.add(vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("atendimento-adicionado-sucesso"),
              });
              this.$refs[formName].resetFields();
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    editForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading({
            lock: true,
            text: i18n.tc("carregando"),
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          CallCenterService.update(vm.id, vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("atendimento-atualizado-sucesso"),
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted() {
    const vm = this;
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      vm.get();
    } else {
      vm.$refs.code.$el.children[0].focus();
    }
  },
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}
form {
  margin-top: 20px;
}
@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}
</style>
